module.exports = __webpack_public_path__ + "img/manufacture.0a29481.webp";